<template>
    <div>
        <header-message class="mt-3 mb-3 text-warning">Auggie Device Upgrade Required</header-message>
        <header-message class="mb-3 desc">
            Click Proceed to download and install the upgrade now.
            Otherwise press the Power Off button to postpone this required upgrade.
        </header-message>
        <header-message class="mb-3 desc text-warning">
            Make sure that the battery level is sufficient to complete this upgrade.
        </header-message>
        <header-message v-if="releaseNotes" class="mb-3 desc">
            {{ releaseNotes }}
        </header-message>

        <div class="buttondiv mt-5 mb-5">
            <button-button class="btn btn-primary" type="submit" @click.prevent="proceedClicked">Proceed</button-button>
        </div>
        <power-off />
    </div>
</template>

<style scoped lang="scss">
    .buttondiv {
        text-align:center;
    }
</style>

<style lang="scss">
    .desc.status {
        font-size: 1.5rem;
        font-style: normal;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import PowerOff from "@/components/PowerOff.vue";
import { Global } from "@/support/GlobalData";

export default defineComponent({
    name: "UpgradeRequired",
    mixins: [PageBase],
    components: {
        HeaderMessage,
        PowerOff,
    },
    computed: {
        releaseNotes(): string {
            if (!Global.PackageUpgrade) return "";
            return Global.PackageUpgrade?.ReleaseNotes;
        },
    },
    methods: {
        proceedClicked(): void {
            if (Auggie.PackageDownload.IsAborted()) {
                this.$router.push("/Upgrade/Failed");
            } else {
                this.$router.push("/Upgrade/Download");
            }
        },
    },
});
</script>
